import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type * as Schemas from "@msuite/utils/schemas";
import type { TransportOrderList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useTransportOrders(query?: Schemas.GetTransportOrdersQuerySchema) {
	/** Query */
	const result = useQuery({
		queryKey: ["transport-orders", query ? JSON.stringify(query) : ""],
		queryFn: async () => {
			const response = await client.stock["transport-orders"].$get({ query: query ?? {} });
			const data = await responseHandler(response);
			return data.transportOrders as TransportOrderList;
		},
	});

	/** Return */
	return { ...result, transportOrders: (result.data || []) as TransportOrderList };
}
